import { useQuery } from '@tanstack/react-query';
import type { SnakifiedIntegrationT } from 'routes/IntegrationsList/types';
import { RQAPICallWithData } from 'store/APIClient';

export const SNAKIFIED_INTEGRATIONS_QUERY_KEY = 'snakifiedIntegrations';

// TODO: merge with shared/api/integrations/useAPIGetIntegrations (same GET /integrations endpoint):
// - add a `skipCaseConversion` param and include it in the query key to avoid mixing both cache shapes
// - drop `initialData: []` (it would be considered fresh with the shared hook's staleTime)
// - update useAPIUpdateIntegrationParameter to target/invalidate the right query key
export const useGetAPIIntegrations = () =>
    useQuery({
        queryKey: [SNAKIFIED_INTEGRATIONS_QUERY_KEY],

        queryFn: async () => {
            const response = await RQAPICallWithData<SnakifiedIntegrationT[]>({
                endpoint: '/integrations',
                method: 'GET',
                skipCaseConversion: true,
            });
            return [...response.content.data].sort((a, b) =>
                a.slug.localeCompare(b.slug),
            );
        },

        initialData: [],
    });
